import script from "./PerformerQualities.vue?vue&type=script&setup=true&lang=js"
export * from "./PerformerQualities.vue?vue&type=script&setup=true&lang=js"

import "./PerformerQualities.vue?vue&type=style&index=0&id=68105cb6&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68105cb6"]])

export default __exports__